module.exports = __webpack_public_path__ + "src/assets/static/img/icn_close.b44a4d3e.svg";